<template>
	<v-main>
		<v-container fluid>
			<v-card width="100%" outlined elevation-0>
				<v-toolbar flat class="border_bottom" shaped>
					<v-btn icon class="mr-1" :title="ret ? ret.label : 'Torna ai siti'" @click="back"><v-icon>mdi-arrow-left</v-icon></v-btn>
					<v-toolbar-title>Competitor · Analisi prezzi</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn text title="Aggiorna" @click="carica"><v-icon>mdi-refresh</v-icon></v-btn>
				</v-toolbar>

				<v-card-text class="pb-0">
					<v-alert type="info" dense text dismissible>
						Per ogni nostro prodotto abbinato: in <span class="green--text text--darken-2 font-weight-bold">verde</span> i siti dove siamo più economici, in
						<span class="red--text font-weight-bold">rosso</span> quelli dove siamo più cari. Il suggerimento è un centesimo sotto il concorrente più economico.
					</v-alert>
					<v-row dense align="center">
						<v-col cols="12" md="6">
							<v-btn-toggle v-model="filtro" mandatory dense color="primary" @change="ricarica">
								<v-btn small value="all">Tutti</v-btn>
								<v-btn small value="beaten">Siamo più cari</v-btn>
								<v-btn small value="winning">Siamo più economici</v-btn>
							</v-btn-toggle>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field v-model="cerca" label="Cerca per nome, SKU o EAN" outlined dense hide-details clearable append-icon="mdi-magnify" @keyup.enter="ricarica" @click:append="ricarica" @click:clear="onClear"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>

				<analysis-table :rows="righe" :sites="siti" :total="totale" :options="opzioni" :loading="caricamento" @update:options="onOpzioni" @apply="apriApplica"></analysis-table>
			</v-card>
		</v-container>

		<apply-price-dialog v-model="dialogApplica" :row="rigaApplica" :saving="salvando" :error="erroreApplica" @confirm="applica"></apply-price-dialog>
		<v-snackbar v-model="snack.visibile" :color="snack.colore" timeout="5000">{{ snack.testo }}</v-snackbar>
	</v-main>
</template>

<script>
import AnalysisTable from '../../components/competitor/AnalysisTable.vue';
import ApplyPriceDialog from '../../components/competitor/ApplyPriceDialog.vue';
import { testoErrore } from '../../components/competitor/testi';
import { withNewPrice, money } from './pricing';
import { returnInfo, goBackWithResult } from '@/components/core/pageReturn';

const chiave = r => `${r.item}|${r.variantSku || ''}`;

export default {
	name: 'CompetitorAnalysis',
	components: { AnalysisTable, ApplyPriceDialog },
	data() {
		// filtro, ricerca e pagina arrivano dall'URL: refresh e link ripartono uguali
		const q = this.$route.query;
		const perPage = parseInt(q.perPage, 10);
		return {
			// aperta da un'altra pagina (es. consigli della scheda prodotto): la freccia riporta li'
			ret: returnInfo(this.$route),
			filtro: ['beaten', 'winning'].includes(q.stato) ? q.stato : 'all',
			cerca: q.q ? String(q.q) : '',
			righe: [],
			siti: [],
			totale: 0,
			caricamento: false,
			caricato: false,
			opzioni: { page: parseInt(q.page, 10) > 0 ? parseInt(q.page, 10) : 1, itemsPerPage: [25, 50, 100].includes(perPage) ? perPage : 50 },
			dialogApplica: false,
			rigaApplica: null,
			salvando: false,
			erroreApplica: '',
			snack: { visibile: false, testo: '', colore: 'success' },
		};
	},
	methods: {
		back() {
			if (this.ret) return goBackWithResult(this.$router, this.ret, '', null);
			this.$router.push({ name: 'competitor' });
		},
		mostra(testo, colore = 'success') {
			this.snack = { visibile: true, testo, colore };
		},
		onOpzioni(opzioni) {
			const cambiate = opzioni.page !== this.opzioni.page || opzioni.itemsPerPage !== this.opzioni.itemsPerPage;
			// primo avviso della tabella (ancora senza totale): vale la pagina letta dall'URL
			this.opzioni = this.caricato ? opzioni : { ...opzioni, page: this.opzioni.page, itemsPerPage: this.opzioni.itemsPerPage };
			if (cambiate || !this.caricato) {
				this.caricato = true;
				this.carica();
			}
		},
		onClear() {
			this.cerca = '';
			this.ricarica();
		},
		ricarica() {
			if (this.opzioni.page !== 1) {
				this.opzioni = { ...this.opzioni, page: 1 };
			}
			this.carica();
		},
		syncUrl() {
			const query = {};
			if (this.filtro !== 'all') query.stato = this.filtro;
			if (this.cerca) query.q = this.cerca;
			if (this.opzioni.page > 1) query.page = String(this.opzioni.page);
			if (this.opzioni.itemsPerPage !== 50) query.perPage = String(this.opzioni.itemsPerPage);
			// il ritorno alla pagina che l'ha aperta deve reggere un refresh
			if (this.$route.query.from) query.from = String(this.$route.query.from);
			if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) this.$router.replace({ query }).catch(() => {});
		},
		async carica() {
			this.syncUrl();
			this.caricamento = true;
			const res = await this.$store.dispatch('competitor/fetchAnalysis', {
				q: this.cerca || undefined,
				status: this.filtro,
				page: this.opzioni.page,
				limit: this.opzioni.itemsPerPage > 0 ? this.opzioni.itemsPerPage : 100,
			});
			this.caricamento = false;
			if (res.error) {
				this.mostra(testoErrore(res.error), 'error');
				return;
			}
			this.siti = (res.sites || []).map(s => ({ ...s, _id: String(s._id) }));
			this.righe = (res.rows || []).map(r => ({ ...r, _key: chiave(r) }));
			this.totale = res.total || 0;
		},
		apriApplica(riga) {
			this.rigaApplica = riga;
			this.erroreApplica = '';
			this.dialogApplica = true;
		},
		async applica(prezzo) {
			const riga = this.rigaApplica;
			this.salvando = true;
			this.erroreApplica = '';
			const res = await this.$store.dispatch('competitor/applyPrice', { itemId: riga.item, variantSku: riga.variantSku || null, price: prezzo });
			this.salvando = false;
			if (res.error) {
				this.erroreApplica = testoErrore(res.error);
				return;
			}
			const nuovo = res.item && res.item.pricevat !== undefined && res.item.pricevat !== null ? Number(res.item.pricevat) : prezzo;
			const i = this.righe.findIndex(r => r._key === riga._key);
			if (i >= 0) this.$set(this.righe, i, { ...withNewPrice(this.righe[i], nuovo), lastApplyAt: new Date() });
			this.dialogApplica = false;
			this.mostra(`Prezzo aggiornato a ${money(nuovo)}.`);
		},
	},
};
</script>
